// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Client from "@apollo/client";
import * as ApolloClient__Utils from "../../../../ApolloClient__Utils.bs.js";
import * as ApolloClient__React_Types from "../types/ApolloClient__React_Types.bs.js";

var Js_ = {};

function useLazyQuery(Operation, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, param) {
  var safeParse = function (param) {
    return ApolloClient__Utils.safeParse(Operation.parse, param);
  };
  var jsQueryTuple = Client.useLazyQuery(Operation.query, ApolloClient__React_Types.LazyQueryHookOptions.toJs({
            query: undefined,
            displayName: displayName,
            onCompleted: onCompleted,
            onError: onError,
            client: client,
            context: context,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            nextFetchPolicy: nextFetchPolicy,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            partialRefetch: partialRefetch,
            pollInterval: pollInterval,
            ssr: ssr,
            variables: undefined
          }, safeParse, Operation.serializeVariables));
  return ApolloClient__Utils.useGuaranteedMemo1((function (param) {
                return ApolloClient__React_Types.QueryTuple.fromJs(jsQueryTuple, safeParse, Operation.serialize, Operation.serializeVariables);
              }), jsQueryTuple);
}

function useLazyQueryWithVariables(Operation, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, $staropt$star, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, variables) {
  var mapJsVariables = $staropt$star !== undefined ? $staropt$star : (function (prim) {
        return prim;
      });
  var safeParse = function (param) {
    return ApolloClient__Utils.safeParse(Operation.parse, param);
  };
  var jsQueryTuple = Client.useLazyQuery(Operation.query, ApolloClient__React_Types.LazyQueryHookOptions.toJs({
            query: undefined,
            displayName: displayName,
            onCompleted: onCompleted,
            onError: onError,
            client: client,
            context: context,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            nextFetchPolicy: nextFetchPolicy,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            partialRefetch: partialRefetch,
            pollInterval: pollInterval,
            ssr: ssr,
            variables: Caml_option.some(variables)
          }, safeParse, Operation.serializeVariables));
  return ApolloClient__Utils.useGuaranteedMemo1((function (param) {
                return ApolloClient__React_Types.QueryTuple__noVariables.fromJs(jsQueryTuple, mapJsVariables, safeParse, Operation.serialize, Operation.serializeVariables, variables);
              }), jsQueryTuple);
}

var ApolloClient;

var ApolloError;

var ErrorPolicy;

var Graphql;

var LazyQueryHookOptions;

var QueryTuple;

var QueryTuple__noVariables;

var Types;

var Utils;

var WatchQueryFetchPolicy;

export {
  ApolloClient ,
  ApolloError ,
  ErrorPolicy ,
  Graphql ,
  LazyQueryHookOptions ,
  QueryTuple ,
  QueryTuple__noVariables ,
  Types ,
  Utils ,
  WatchQueryFetchPolicy ,
  Js_ ,
  useLazyQuery ,
  useLazyQueryWithVariables ,
}
/* @apollo/client Not a pure module */
